var _circle, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "url(#paint0_linear)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3903 20.88V19.3C29.3903 16.38 26.9719 14 24.0149 14H23.9845C21.0275 14 18.6091 16.361 18.5989 19.3V20.88C19.0765 20.721 19.5846 20.63 20.113 20.63H20.1231V19.28C20.1333 17.191 21.8607 15.5 23.9946 15.5H24.0048C26.1387 15.5 27.8661 17.21 27.8661 19.3V20.63H27.8763C28.3861 20.63 28.8865 20.7147 29.341 20.8635C28.8866 20.7148 28.3863 20.6301 27.8766 20.6301H20.1133C19.5849 20.6301 19.0768 20.7211 18.5992 20.8801C16.8007 21.5001 15.5 23.1811 15.5 25.17V29.46C15.5 31.96 17.5729 34 20.1133 34H27.8766C30.4271 34 32.5 31.96 32.5 29.46V25.17C32.5 23.1811 31.1993 21.5001 29.3906 20.8801C29.3905 20.88 29.3904 20.88 29.3903 20.88ZM24.8891 28.42C24.8891 28.91 24.4928 29.3 23.9949 29.3C23.5072 29.3 23.1109 28.91 23.1109 28.42V26.2C23.1109 25.721 23.5072 25.33 23.9949 25.33C24.4928 25.33 24.8891 25.721 24.8891 26.2V28.42Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 24,
    y1: 48,
    x2: 24,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5781E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC148"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocked);
export default __webpack_public_path__ + "static/media/locked.7c882c8d3dc5ef7dc788f86f2b3e2f1e.svg";
export { ForwardRef as ReactComponent };